<!-- d:\项目\搏忆购PC\boyigou_web_new\src\views\shopCenter\buyer.vue -->
<template>
  <div class="buyer-center">
    <!-- 头部组件 -->
    <center-header />

    <!-- 主体内容区域 -->
    <div class="main-content">
      <div class="container">
        <!-- 左侧菜单组件，监听菜单选择事件 -->
        <center-left :menu-list="buyerMenuList" :default-active="currentComponent" @menu-select="handleMenuSelect" />

        <!-- 右侧动态内容区域 -->
        <div class="right-content">
          <!-- 根据当前选择的组件动态渲染 -->
          <component :is="currentComponent" />
        </div>
      </div>
    </div>
    <!-- 底部组件 -->
    <Footer />
  </div>
</template>

<script>
import CenterHeader from './components/CenterHeader.vue'
import CenterLeft from './components/CenterLeft.vue'
import Footer from '../../components/Footer.vue'

// 异步加载买家中心组件，提升初始加载性能
import PersonalInfo from './components/buyerComponents/PersonalInfo.vue'
import MemberCenter from './components/buyerComponents/MemberCenter.vue'
import MyOrders from './components/buyerComponents/MyOrders.vue'
import MyPurchases from './components/buyerComponents/MyPurchases.vue'
import MyWallet from './components/buyerComponents/MyWallet.vue'
import MyFavorites from './components/buyerComponents/MyFavorites.vue'
import MyFollows from './components/buyerComponents/MyFollows.vue'
import MyCoupons from './components/buyerComponents/MyCoupons.vue'
import AddressManagement from './components/buyerComponents/AddressManagement.vue'
import InvoiceManagement from './components/buyerComponents/InvoiceManagement.vue'
import SettlementStatements from './components/buyerComponents/SettlementStatements.vue'

// 允许访问的组件列表，使用对象提高查找效率
const ALLOWED_COMPONENTS = {
  PersonalInfo,
  MemberCenter,
  MyOrders,
  MyPurchases,
  MyWallet,
  MyFavorites,
  MyFollows,
  MyCoupons,
  AddressManagement,
  InvoiceManagement,
  SettlementStatements
}

export default {
  name: 'BuyerCenter',
  components: {
    CenterHeader,
    CenterLeft,
    Footer,
    // 注册所有允许的组件
    ...ALLOWED_COMPONENTS
  },
  data() {
    return {
      userInfo: {},
      currentComponent: 'PersonalInfo', // 默认显示个人信息组件
      componentKey: 0, // 用于强制刷新组件
      componentParams: {} // 传递给组件的参数
    }
  },
  computed: {
    buyerMenuList() {
      return [
        { index: 'PersonalInfo', label: '个人信息' },
        { index: 'MemberCenter', label: '会员中心' },
        { index: 'MyOrders', label: '我的订单' },
        { index: 'MyPurchases', label: '我的采购' },
        { index: 'SettlementStatements', label: '结算单' },
        { index: 'MyWallet', label: '我的钱包' },
        { index: 'MyFavorites', label: '我的收藏' },
        { index: 'MyFollows', label: '我的关注' },
        { index: 'MyCoupons', label: '我的优惠券' },
        { index: 'AddressManagement', label: '地址管理' },
        { index: 'InvoiceManagement', label: '发票管理' }
      ]
    }
  },
  created() {
    // 从路由参数获取组件名称
    const componentName = this.$route.query.component || this.$route.query.componentName || 'PersonalInfo'

    // 检查组件名是否在允许的列表中
    const allowedComponentNames = Object.keys(ALLOWED_COMPONENTS);
    if (allowedComponentNames.includes(componentName)) {
      this.currentComponent = componentName;
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      try {
        const res = await this.$api.userInfo()
        this.userInfo = res
        this.$store.dispatch('updateUserInfo', res)
      } catch (err) {
        this.$message.warning('获取用户信息失败：' + (err.message || err))
      }
    },
    handleMenuSelect(componentName) {
      // 只有当要切换的组件与当前组件不同时才执行切换
      if (this.currentComponent !== componentName) {
        this.currentComponent = componentName;
        this.componentKey += 1; // 强制刷新组件
        // 更新URL参数
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            component: componentName
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.buyer-center {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.main-content {
  flex: 1;
  padding: 20px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  gap: 20px;
}

.right-content {
  flex: 1;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .center-left {
    width: 100%;
  }

  .left-menu {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
  }

  ::v-deep .el-menu--vertical .el-menu-item {
    display: inline-block;
    border-left: none;
    border-bottom: 3px solid transparent;
  }

  ::v-deep .el-menu-item.is-active {
    border-left-color: transparent;
    border-bottom-color: #286CED;
  }
}

.center-left {
  flex-shrink: 0;
}
</style>